// extracted by mini-css-extract-plugin
export default {"container":"Uploads_container__tXMbN","card":"Uploads_card__N0tME","summaryTitle":"Uploads_summaryTitle__Eh0HA","formLegend":"Uploads_formLegend__DlCNS"};